import useGetCrmSessionHook from "Hooks/CrmSessionHook";
import { CONSTANTS } from "consts";
import { Action, UserAppContext } from "contexts";
import { useContext, useEffect, useState } from "react";
import { useHistory, useLocation } from "react-router-dom";
import { mobileDetect } from "scripts/mobileDetect";
import { useCheckLogbookConnectedMutation, useCheckStravaConnectedMutation, useGameSyncWorkoutMutation, useLogbookSyncWorkoutMutation } from 'services/crmServer';
import Swal from 'sweetalert2';
import {
    handleChangeChartOption,
    useHandleGetWorkoutDetail,
    useHandleGetWorkoutList,
} from "../handleActions";

export const useMainHook = () => {
    const isMobile = mobileDetect();
    const history = useHistory();

    const [syncStrava] = useGameSyncWorkoutMutation();
    const [syncLogbook] = useLogbookSyncWorkoutMutation();
    const [checkStravaConnected] = useCheckStravaConnectedMutation();
    const [checkLogbookConnected] = useCheckLogbookConnectedMutation();
    const { handleGetWorkoutList } = useHandleGetWorkoutList();
    const { handleGetWorkoutDetail } = useHandleGetWorkoutDetail();

    const { auth, workoutState, authDispatch, workoutDispatch, timezone } =
        useContext(UserAppContext);
    const timeZone = timezone.timezone;
    const {
        chartData,
        chartOptions,
        workoutMetrics,
        historyList,
        loading,
        currentSelect,
        metaData,
        workoutDetail,
    } = workoutState;
    const [workoutId, setWorkoutId] = useState('');
    const [timeRange, setTimeRange] = useState(0);
    const [isExpandActivity, setIsExpandActivity] = useState(!isMobile);
    const [isStravaConnected, setIsStravaConnected] = useState(false);
    const [isLogbookConnected, setIsLogbookConnected] = useState(false);
    const [hideSelectTimeRage, setHideSelectTimeRage] = useState(false);
    const location = useLocation();
    const search = location.search;
    const searchParams = new URLSearchParams(search);
    const pageParam = searchParams.get("page")
        ? Number(searchParams.get("page"))
        : 1;
    const startTime = searchParams.get("startTime") || "";
    const endTime = searchParams.get("endTime") || "";
    const pageSize = 10;

    useEffect(() => {
        // && auth.crmUserId 
        if (auth) {
            handleGetWorkoutList(
                {
                    isChangePage: true,
                    timeRange: timeRange,
                    page: pageParam,
                    userData: auth,
                    startTime,
                    endTime,
                    pageSize,
                    isGetMetric: false,
                    timeZone,
                },
                workoutDispatch
            );
            if (startTime !== "" && endTime !== "") {
                setHideSelectTimeRage(true);
            }
        }
    }, [location, auth]);

    useEffect(() => {
        if (workoutState.currentUnit && workoutId !== '') {
            const appId = localStorage.getItem("appId");
            if (
                appId === String(CONSTANTS.APP.AVIRON_TREADMILL) ||
                appId === String(CONSTANTS.APP.AVIRON_BIKE)
            ) {
                let unitType: 0 | 1 | 2 = 2;
                if (workoutState.currentUnit === "miles") {
                    unitType = 1;
                }
                handleGetWorkoutDetail(
                    { workoutId, userData: auth, unitType },
                    workoutDispatch
                );
            }
        }
    }, [workoutState.currentUnit, workoutId])

    const handleSelectTimeRange = (event: any) => {
        const timeRange = event.target.value;
        setTimeRange(timeRange);
        handleGetWorkoutList(
            {
                timeRange,
                page: 1,
                userData: auth,
                pageSize,
                isGetMetric: false,
                timeZone,
            },
            workoutDispatch
        );
    };
    const handleSelectHistoryItem = (newWorkoutId: string) => {
        if (newWorkoutId !== currentSelect.workoutItem && newWorkoutId) {
            const appId = localStorage.getItem("appId");
            if (
                appId === String(CONSTANTS.APP.AVIRON_TREADMILL) ||
                appId === String(CONSTANTS.APP.AVIRON_BIKE)
            ) {
                let unitType: 0 | 1 | 2 = 2;
                if (workoutState.currentUnit === "miles") {
                    unitType = 1;
                }
                handleGetWorkoutDetail(
                    { workoutId: newWorkoutId, userData: auth, unitType },
                    workoutDispatch
                );
                setWorkoutId(newWorkoutId);
            } else {
                handleGetWorkoutDetail(
                    { workoutId: newWorkoutId, userData: auth },
                    workoutDispatch
                );
            }
        }
    };

    const handleSelectChartOption = (value: number) => {
        handleChangeChartOption({ value }, workoutDispatch);
    };

    const handlePrevPage = () => {
        history.push(
            `${CONSTANTS.NAVIGATION_URL.WORKOUT_HISTORY_DETAIL}?page=${metaData.currentPage - 1
            }&startTime=${startTime}&endTime=${endTime}`
        );
        window.scrollTo({ top: 0, left: 0 });
    };

    const handleNextPage = () => {
        history.push(
            `${CONSTANTS.NAVIGATION_URL.WORKOUT_HISTORY_DETAIL}?page=${metaData.currentPage + 1
            }&startTime=${startTime}&endTime=${endTime}`
        );
        window.scrollTo({ top: 0, left: 0 });
    };

    const handleFirstPage = () => {
        history.push(
            `${CONSTANTS.NAVIGATION_URL.WORKOUT_HISTORY_DETAIL
            }?page=${1}&startTime=${startTime}&endTime=${endTime}`
        );
        window.scrollTo({ top: 0, left: 0 });
    };
    const handleLastPage = () => {
        history.push(
            `${CONSTANTS.NAVIGATION_URL.WORKOUT_HISTORY_DETAIL}?page=${metaData.lastPage}&startTime=${startTime}&endTime=${endTime}`
        );
        window.scrollTo({ top: 0, left: 0 });
    };
    const toggleViewMoreActivity = () => {
        setIsExpandActivity(!isExpandActivity);
    };

    const handleSyncToStrava = async () => {
        const appId = localStorage.getItem("appId");
        let machine = "rower";
        if (appId && Number(appId) === CONSTANTS.APP.C2_BIKEERG) {
            machine = "bike";
        }
    };

    const handleSyncToLogbook = async () => {
        const appId = localStorage.getItem("appId");
        let machine = "rower";
        if (appId && Number(appId) === CONSTANTS.APP.C2_BIKEERG) {
            machine = "bike";
        }
    };

    return {
        isStravaConnected,
        historyList,
        chartOptions,
        loading,
        currentSelect,
        timeRange,
        isMobile,
        chartData,
        isExpandActivity,
        workoutMetrics,
        workoutDetail,
        metaData,
        handleSyncToStrava,
        toggleViewMoreActivity,
        handleNextPage,
        handlePrevPage,
        handleFirstPage,
        handleLastPage,
        handleSelectChartOption,
        handleSelectHistoryItem,
        handleSelectTimeRange,
        hideSelectTimeRage,
        isLogbookConnected,
        handleSyncToLogbook,
    };
};
